export default __webpack_public_path__ + "static/media/login-background-left.4c312977.png";